import { FC } from 'react';
import dayjs from 'dayjs';
import { DATE_DISPLAY_FORMAT } from '@aleph/shared-components';
import { ICellRendererParams } from 'ag-grid-community';

const RedditReportDateCellRenderer: FC<ICellRendererParams & { addCurrency?: boolean, divisor?: number }> = (params) => (
	<div className="px-[8px]">
		{dayjs(params.value).format(DATE_DISPLAY_FORMAT)}
	</div>
);

export default RedditReportDateCellRenderer;
